export default __webpack_public_path__ + "static/media/camera-hover.9d6e725d.svg";